import React from "react";
import "./Testimonials.css";
import { testimonials } from "../../portfolio";

const Testimonials = ({ theme }) => {
  return (
    <div className="testimonials-container" id="testimonials">
      <div className="testimonials-header">
        <h2 className="testimonials-title" style={{ color: theme.text }}>
          What People Say
        </h2>
        <div
          className="testimonials-subtitle"
          style={{ color: theme.secondaryText }}
        >
          Testimonials from colleagues, managers, and collaborators
        </div>
      </div>

      <div className="testimonials-grid">
        {testimonials.testimonials.map((testimonial, index) => (
          <div
            key={index}
            className="testimonial-card"
            style={{ backgroundColor: theme.cardBackground }}
          >
            <div className="testimonial-content">
              <div className="testimonial-quote">
                <i
                  className="fas fa-quote-left"
                  style={{ color: theme.imageHighlight }}
                ></i>
              </div>

              <p className="testimonial-text" style={{ color: theme.text }}>
                {testimonial.testimonial}
              </p>

              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i
                    key={i}
                    className="fas fa-star"
                    style={{ color: "#FFD700" }}
                  ></i>
                ))}
              </div>
            </div>

            <div className="testimonial-author">
              <div className="author-info">
                <h4 className="author-name" style={{ color: theme.text }}>
                  {testimonial.name}
                </h4>
                <p
                  className="author-position"
                  style={{ color: theme.secondaryText }}
                >
                  {testimonial.position}
                </p>
                <p
                  className="author-company"
                  style={{ color: theme.imageHighlight }}
                >
                  {testimonial.company}
                </p>
              </div>

              {testimonial.linkedin && (
                <div className="testimonial-links">
                  <a
                    href={testimonial.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="linkedin-link"
                    style={{ color: theme.imageHighlight }}
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
